import React from 'react';
import styled from 'styled-components';
import { AnchorLink } from 'gatsby-plugin-anchor-links';

const Holder = styled.nav`
  position: fixed;
  z-index: 100;
  top: 50%;
  right: 2rem;
  transform: translateY(-50%);
  ${props => props.theme.showLarge()}
  ul {
    list-style: none;
    padding-left: 0;
    text-align: right;
    li {
      margin: 1rem 0;
      a {
        text-decoration: none;
        position: relative;
        &:after {
          content: '';
          display: inline-block;
          width: 1rem;
          height: 1rem;
          border: 1px solid;
          border-radius: 50%;
          margin-left: 1rem;
        }
        &:hover:after {
          background-color: ${props => props.theme.colours.black};
        }
      }
    }
  }
`;

function Navigation() {

  return (
    <Holder>
      <ul>
        <li className="caps"><AnchorLink to="/#anchor-intro" title="Intro">Intro</AnchorLink></li>
        <li className="caps"><AnchorLink to="/#anchor-part-1" title="Part 1">1</AnchorLink></li>
        <li className="caps"><AnchorLink to="/#anchor-part-2" title="Part 2">2</AnchorLink></li>
        <li className="caps"><AnchorLink to="/#anchor-part-3" title="Part 3">3</AnchorLink></li>
        <li className="caps"><AnchorLink to="/#anchor-conclusion" title="Conclusion">4</AnchorLink>
        </li>
      </ul>
    </Holder>
  )
}

export default Navigation;
